module.exports = __webpack_public_path__ + "img/37_44.3832b78e.png";